var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CircularProgress } from '../../../../../components';
export var InputControlLoading = function (_a) {
    var loading = _a.loading;
    if (!loading)
        return null;
    return _jsx(_Fragment, { children: _jsx("div", { children: _jsx("div", __assign({ style: { padding: '0 4px' } }, { children: _jsx(CircularProgress, { color: "inherit", size: 12, thickness: 5 }) })) }) });
};
